// Docs: https://inlineattachment.readthedocs.io/en/latest/pages/configuration.html
$(function () {
  'use strict';

  $(function () {
    var $token = $("meta[name='csrf-token']").attr('content');
    var $textarea = $('textarea.js-markdown-file');
    $textarea.inlineattachment({
      uploadUrl: $textarea.data('fileupload-url'),
      uploadMethod: 'POST',
      allowedTypes: ['image/jpeg', 'image/png', 'image/jpg'],
      extraParams: { 'authenticity_token': $token },
      jsonFieldName: 'filename',                  // レスポンスに設定するURLの項目名
      urlText: '![markdown_file]({filename})'  // Drag&Dropしたら、urlを作成
    });
  });
});
